module.exports = __webpack_public_path__ + "img/team.ba7c7fde.svg";